/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * Navigation History service
 */

namespace Application.Services {
    'use strict';

    /**
     * NavigationHistoryService
     */
    export class NavigationHistoryService {
        public static $name: string = "navigationHistoryService";
        public static $inject: string[] = ['$window'];

        private static MAXIMUN_HISTORY_SIZE: number = 10;

        private navigationHistory: string[] = [];

        constructor(private $window: ng.IWindowService) {
            // empty constructor
        }

        public getPreviousLocation(): string {
            let previousLocation: string;
            if (this.navigationHistory.length > 1) {
                previousLocation = this.navigationHistory[this.navigationHistory.length - 2];
                return previousLocation;
            } else {
                return this.navigationHistory[0];
            }
        }

        public getLastLocation(): string {
            return this.navigationHistory[this.navigationHistory.length - 1];
        }

        public pushLocation(location: string): void {
            this.navigationHistory.push(location);
            if (this.navigationHistory.length > NavigationHistoryService.MAXIMUN_HISTORY_SIZE) {
                this.navigationHistory.shift();
            }
        }

        public goBack(): void {
            let previousLocation: string = "#!" + this.getPreviousLocation() + Common.Utils.getUrlParameters(this.$window.location.href);
            this.navigationHistory.splice(-1);
            this.$window.location.href = previousLocation;
        }

        public getSizeOfHistory(): number {
            if (this.navigationHistory) {
                return this.navigationHistory.length;
            } else {
                return undefined;
            }
        }

        public getNavigationHistory(): string[] {
            return this.navigationHistory;
        }
    }
}